import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './lib/auth';
import './index.css';

// React Query defaults for the dashboard.
//
// refetchInterval: 10_000 — every page in the Command Deck (Inbox,
// Meetings, Focus, Agreements, Action Items) reads from tables that
// agents write to in the background. Before this, queries cached at
// mount stayed frozen until a hard reload — users sent a fresh email,
// the draft worker INSERTed a new approval, and the UI didn't show it
// until they refreshed the tab. 10s polling gives an end-to-end
// "live-ish" feel without saturating the API (RLS-scoped indexes on
// small tables, plus React Query dedupes simultaneous refetches).
//
// staleTime stays below the interval so the refetch actually fires.
// `refetchIntervalInBackground: false` means the timer pauses when the
// tab is hidden — no point polling when no one's looking.
//
// Supabase realtime subscriptions are the right long-term fix for
// instant updates; tracked for next-week's UI iteration.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchInterval: 10_000,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root in index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
